import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import * as PropTypes from 'prop-types';

import GenericModal from '../../containers/modal/generic_modal';
import {BUTTON_COLOR, BUTTON_STYLE} from '../../constants';
import VideoShownMutation from '../../mutations/video_shown_mutation';
import Util from '../../forecast-app/shared/util/util';

export const TutorialVideo = injectIntl(({videoId, viewerId, videosShown, youtubeId, intl: {formatMessage}}) => {
	const [showVideo, setShowVideo] = useState(videosShown.indexOf(videoId) === -1);

	// Fire the video shown mutation in the background as we don't care when it is done. It's important that the user can
	// quickly move on from it.
	const closeVideo = () => {
		Util.CommitMutation(VideoShownMutation, {
			viewerId,
			videoId,
			videosShown,
		});

		setShowVideo(false);
	};

	const getVideoEmbedCode = () => {
		if (youtubeId) {
			return (
				<iframe
					title="forecast-budget-tutorial"
					style={{
						width: '700px',
						height: '394px',
					}}
					src={`https://www.youtube.com/embed/${youtubeId}`}
					frameBorder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			);
		} else {
			// eslint-disable-next-line no-console
			console.error(`No video embed id is defined, so can't show any video`);
			return null;
		}
	};

	return showVideo ? (
		<GenericModal
			closeModal={closeVideo}
			content={getVideoEmbedCode()}
			buttons={[
				{
					text: formatMessage({id: 'common.ok'}),
					color: BUTTON_COLOR.GREEN,
					style: BUTTON_STYLE.FILLED,
					cy: 'budget-tutorial-ok-button',
				},
			]}
		/>
	) : null;
});

TutorialVideo.propTypes = {
	/**
	 * The ID of the viewer. This is used to make sure that the relay cache is updates after video is shown.
	 */
	viewerId: PropTypes.string.isRequired,
	/**
	 * The ID of the video. This is used to check in the viewer if the video has already been shown. Also used to mark the video as have been shown, when the user closes the modal.
	 */
	videoId: PropTypes.string.isRequired,
	/**
	 * A list of shown videos, taken from the Viewer.
	 */
	videosShown: PropTypes.arrayOf(PropTypes.string).isRequired,
	youtubeId: PropTypes.string,
};
